export function capitalizeFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function duration(diff) {
  if (diff < 3600) {
    return `${~~(diff / 60)} min`
  } else if (diff < 86400) {
    return `${~~(diff / 3600)} h`
  } else if (diff < 2592000) {
    return `${~~(diff / 86400)} d`
  }

  return `${~~(diff / 2592000)} mo`
}

// TODO: move to i18n
export const dayDifference = (() => {
  const MINUTE = 60
  const HOUR = 60 * MINUTE
  const DAY = 24 * HOUR
  const MONTH = 30 * DAY
  const YEAR = 365 * DAY
  const humanTimes = [
    [1, 'sec'],
    [MINUTE, 'min'],
    [HOUR, 'h'],
    [DAY, 'd'],
    [MONTH, 'm'],
    [YEAR, 'y'],
    [YEAR * YEAR],
  ]

  function timeDiff(seconds) {
    const [unit, literal] = humanTimes
      .find((_, index) => seconds < humanTimes[index + 1][0])

    return ~~(seconds / unit) + literal
  }

  return function dayDifference(days) {
    return timeDiff(days * DAY)
  }
})()

// TODO: move to i18n
export function relativeTime(inputDate) {
  const diff = (Date.now() - new Date(inputDate).valueOf()) / 1000
  return diff >= 0
    ? `${duration(diff)} ago`
    : `in ${duration(diff * -1)}`
}

export const metricNumber = number => ['K', 'M', 'B']
  .reduce((accumulator, letter) => parseInt(accumulator, 10) > 1000
    ? Math.round(parseInt(accumulator, 10) / 1000) + letter
    : accumulator,
  number)

// TODO: move to i18n
export const money = (number, places = 2) => {
  const decimalSplit = number.toFixed(places).split('.')
  const isNegative = number < 0
  const out = decimalSplit[0]
    .replace('-', '')

  const decimal = decimalSplit[1] ? `${out},${decimalSplit[1]}` : out

  return isNegative ? '-' + decimal : decimal
}

export const name = person => `${person.firstName || ''} ${person.lastName || ''}`.trim()

export const percent = number => `${number}%`

export const formatEmpty = string => string || '-'

export const slug = (string) => {
  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '') // Remove &
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export function initials({ firstName, lastName }) {
  return [firstName, lastName]
    .filter(x => x)
    .map(name => name[0])
    .join('')
    .toUpperCase()
}
